import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ["bold", "italic", "underline", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};
const formats = ["header", "bold", "italic", "underline", "blockquote", "list", "bullet", "link"];

const RichTextEditor = ({ value, onChange, testId = "rich-text" }) => {
  return (
    <div className="rich-editor bg-paper border border-ink-line rounded" data-testid={testId}>
      <ReactQuill theme="snow" value={value || ""} onChange={onChange} modules={modules} formats={formats} />
    </div>
  );
};

export default RichTextEditor;
